<template>
    <v-container class="d-flex-column justify-center">
        <v-card :loading="loading" class="mt-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Έξοδα</h1>
            <v-spacer></v-spacer>
            <v-chip label>
              {{
              $tocurr(breakdown.cash+breakdown.bank+breakdown.check+breakdown.card+ledgerTotals)
              }}
            </v-chip>
            <v-container fluid class="mt-2">
          <v-row>
            <v-col cols="12" md="2" >
              <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Start date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu = false"
                min="2021-11-01"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="2" >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="End date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                @input="menu2 = false"
                :events="functionEvents"
                min="2021-11-01"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" align="end" >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
            </v-row>
             <v-divider></v-divider>
            <v-sheet class="mt-4">
            <v-row align='center' justify="space-around">
            <v-col>
            <p class="text-body-2 font-weight-bold"><v-icon :color="showBank ? 'blue' : 'black'"  @click.stop="showBank = !showBank">mdi-bank-transfer-in</v-icon> {{ $tocurr(breakdown.bank)}}</p>
            </v-col>
            <v-col>
            <p class="text-body-2 font-weight-bold"><v-icon :color="showCard ? 'primary' : 'black'" @click.stop="showCard = !showCard">mdi-credit-card-chip</v-icon> {{$tocurr(breakdown.card)}}</p>
            </v-col>
            <v-col>
            <p class="text-body-2 font-weight-bold"><v-icon :color="showCash ? 'primary' : 'black'"  @click.stop="showCash = !showCash">mdi-cash-multiple</v-icon> {{$tocurr(breakdown.cash)}}</p>
            </v-col>
            <v-col>
            <p class="text-body-2 font-weight-bold"><v-icon :color="showCheque ? 'primary' : 'black'"  @click.stop="showCheque = !showCheque">mdi-checkbook</v-icon> {{ $tocurr(breakdown.check) }}</p>
            </v-col>
            </v-row>
            </v-sheet>
            </v-container>
              <v-btn
                color="primary"
                dark
                @click="paymdialog=true"
              >
              <v-icon>mdi-cash-register</v-icon>
              </v-btn>
            <ledger-dialog :dialog.sync="paymdialog" apipath="banking/transactions" />
          </v-card-title>

          <v-btn
            color="secondary"
            class="ml-2"
            :loading="htmlLoading"
            @click="fetchHtmlContent"
          >
            <v-icon left>mdi-file-document</v-icon>
            Show Report
          </v-btn>
          </v-card>
          <v-card class="mt-2">
           <v-tabs
             v-model="vtab"
            align-with-title
            >
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab
            v-for="item in vtabs"
            :key="item"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
          </v-card>


      <v-tabs-items :loading="loading" class="mt-2 pa-2" v-model="vtab">
      <v-tab-item :key="vtabs[0]">
       <v-row  fluid class="d-flex">
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Έξοδα</h1>
            <v-spacer/>
            <v-chip label outlined>
            {{ $tocurr(sumField(this.filtDebs, 'TotalValue')) }}
            </v-chip>
            </v-card-title>
          <payments-table :search="search" :debits="filtDebs" contact="Supplier.Name" :loading="loading"></payments-table>
          </v-card>
          </v-col>
           <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Tab</h1>
            <v-spacer/>
            <v-chip label outlined>
            {{ $tocurr(sumField(this.tabs, 'TotalValue')) }}
            </v-chip>
            </v-card-title>
          <invoice-table :search="search" :invoices="tabs" contact="Supplier.Name" :loading="loading"></invoice-table>
          </v-card>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? 12 : 6">
          <v-card class="mt-5" tile>
            <v-card-title>
            <h1 class="mr-2 subheading grey--text">Πάγια</h1>
            <v-spacer/>
            <v-chip label outlined>
            {{ $tocurr(sumField(this.ledger, 'Value')) }}
            </v-chip>
            </v-card-title>
          <ledger-table :search="search" :ledger="ledger" :loading="loading"></ledger-table>
          </v-card>
          </v-col>
          </v-row>
      </v-tab-item>
      <v-tab-item :key="vtabs[1]">

      <v-card
    class="mt-4 mx-auto"
    max-width="100%"
  >
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
   <apexchart
      ref="barChart"
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series"></apexchart>
    </v-sheet>
     <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Πληρωμές Προμηθευτών 2022
      </div>
      <div class="subheading font-weight-light grey--text">
        Πληρωμές προμηθευτών ανά εβδομάδα για το τρέχων έτος.
      </div>
      <v-divider class="my-2"></v-divider>
      <v-icon
        class="mr-2"
        small
      >
        mdi-delta
      </v-icon>
      <span class="text-caption grey--text font-weight-light">Μέση τιμή {{weeklyAvg}}</span>
    </v-card-text>
  </v-card>


    </v-tab-item>
      <v-tab-item :key="vtabs[2]">

      <v-card
      class="mt-4 mx-auto"
    max-width="100%"
  >
      <v-row class="ma-2">
    <v-col cols="12" md="6">
      <v-select
        v-model="selectedUtilities"
        :items="utilitySubs"
        label="Φίλτρο Παγίων"
        multiple
        chips
        clearable
        small-chips
      ></v-select>
    </v-col>
    <v-col cols="12" md="6">
      <v-select
        v-model="selectedTaxes"
        :items="taxSubs"
        label="Φίλτρο Οφειλών"
        multiple
        chips
        clearable
        small-chips
      ></v-select>
    </v-col>
  </v-row>
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="white"
      elevation="0"
      max-width="calc(100% - 32px)"
    >
   <apexchart
      ref="pieChart"
      type="pie"
      height="600"
      :options="pieOptions"
      :series="pieSeries"></apexchart>
    </v-sheet>
     <v-card-text class="pt-0">
      <div class="text-h6 font-weight-light mb-2">
        Πιτα παγίων εξόδων
      </div>
      <div class="subheading font-weight-light grey--text">
        Πάγια έξοδα ανά κατηγορία.
      </div>
    </v-card-text>
  </v-card>


    </v-tab-item>
    </v-tabs-items>

    </v-container>
</template>

<script>

import InvoiceTable from "../components/InvoiceTable.vue";
import LedgerTable from "../components/LedgerTable.vue";
import LedgerDialog from "../components/LedgerDialog.vue";
import PaymentsTable from "../components/PaymentsTable.vue";
import VueApexCharts from 'vue-apexcharts'

export default {

  components: {
    InvoiceTable,
    PaymentsTable,
    LedgerTable,
    LedgerDialog,
    apexchart: VueApexCharts,
  },
  computed: {
    weeklyAvg () {
        var sum = 0;
        if (!this.weekly) return 0;
        for (var el in this.weekly) sum += this.weekly[el];
        return this.$tocurr(sum / Object.keys(this.weekly).length)
    },
    filtDebs () {
        let debs = []
        if (!this.showCash && !this.showBank && !this.showCard && !this.showCheque)
            return this.debits;
        if (this.showCash)
            debs.push(...this.debits.filter(e => e.PaymTerm == 0 || e.PaymTerm == -2))
        if (this.showBank)
            debs.push(...this.debits.filter(e => e.PaymTerm == 1)) // && e.Remarks.includes("@EB")))
        if (this.showCard)
            debs.push(...this.debits.filter(e => e.PaymTerm == 2))
        if (this.showCheque)
            debs.push(...this.debits.filter(e => e.PaymTerm == 3))
        return debs;

    },
  },
  watch: {
    async date() {
      if (this.date != this.$route.query.startdate){
      this.$router.replace({
        name: "Expenses",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
    async date2() {
      if (this.date2 != this.$route.query.enddate){
      this.$router.replace({
        name: "Expenses",
        query: { startdate: this.date, enddate: this.date2 },
      });
      await this.fetchData();
      }
    },
    selectedUtilities() {
    this.prepareLedgerPieChart();
    },
    selectedTaxes() {
      this.prepareLedgerPieChart();
    },

  },
  data() {
    return {
      date: this.isodate(new Date(new Date().setDate(1))), // (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: this.isodate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      ),
      dialog: false,
      paymdialog: false,
      loading: true,
      debTotal: 0.0,
      tabTotal: 0.0,
      showBank: false,
      showCash: false,
      showCard: false,
      showCheque: false,
      ledger: [],
      ledgerTotals: 0, 
      debits: [],
      tabs: [],
      weekly: null,
      vtab: null,
      vtabs: ['Πινακες', 'Γραφημα', 'Πιτα'],
      breakdown: {cash: 0, card: 0, check: 0, bank: 0},
      menu: false,
      menu2: false,
      search: "",
      htmlContent: "",
      htmlLoading: false,


      series: [{
            name: 'Debits',
            data: []
          }],
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar',
          stacked: false,
        },
        plotOptions: {
          bar: {
            columnWidth: '85%',
            borderRadius: 0,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          }
        },
        dataLabels: {
          enabled: true,
          formatter: this.$tocurr,
          offsetY: 40,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },

        xaxis: {
          type: "datetime",
          categories: [],
          position: 'top',
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          crosshairs: {
            fill: {
              type: 'gradient',
              gradient: {
                colorFrom: '#D8E3F0',
                colorTo: '#BED1E6',
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5,
              }
            }
          },
          tooltip: {
            enabled: true,
          }
        },
        legend: {
          position: "top",
          show: true,

        },
        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: true,
          },
          labels: {
            show: true,
            formatter: this.$tocurr,
          }

        },
        responsive: [{
              breakpoint: 480,
              options: {
                legend: {
                  position: 'bottom',
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }],
        //title: {
        //  text: 'Εισπράξεις για το διάστημα',
        //  floating: true,
        //  offsetY: 330,
        //  align: 'center',
        //  style: {
        //    color: '#444'
        //  }
        //}
      },
      utilitySubs: ['ΡΕΥΜΑ', 'ΥΕΠΑΜΑ', 'ΚΙΝΗΤΗ', 'ΤΗΛΕΦΩΝΙΑ/ΙΝΤΕΡΝΕΤ'],
      taxSubs: ['ΦΕΕ', 'ΦΜΥ', 'ΙΚΑ', 'ΦΠΑ', 'ΕΦΚΑ'],
      selectedUtilities: [],
      selectedTaxes: [],
      pieSeries: [],
      ledgerPieLabels: [],
      pieOptions: {
        chart: {
          type: 'pie',
          height: 650,
        },
        labels: [],
        legend: {
          position: 'bottom',
        },
        tooltip: {
          y: {
            formatter: this.$tocurr
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      };
  },
  async created() {
    if (this.$route.query.startdate) {
      this.date = this.$route.query.startdate;
    }
    if (this.$route.query.enddate) {
      this.date2 = this.$route.query.enddate;
    }
    await this.fetchData();
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    isodate(date) {
      return date.toISOString().substr(0, 10);
    },
    async fetchHtmlContent() {
      this.showHtmlDialog = true;
      this.htmlLoading = true;
      try {
        // Adjust the endpoint as needed
        const response = await this.$api.get('/repairs/sankey/data', {
          params: {
            'start-date': this.date,
            'end-date': this.date2,
          },
          headers: { Accept: 'text/html' }
        });
        this.htmlContent = response.data;
        this.openHtmlInNewTab();
      } catch (error) {
        this.htmlContent = "<p style='color:red'>Failed to load report.</p>";
        console.error(error);
      } finally {
        this.htmlLoading = false;
      }
    },
    openHtmlInNewTab() {
    if (!this.htmlContent) return;
    const newWindow = window.open('', '_blank');
    if (newWindow) {
      newWindow.document.write(this.htmlContent);
      newWindow.document.close();
    } else {
      alert('Unable to open new tab. Please allow popups for this site.');
    }
  },
    async fetchData() {
    this.loading = true;
       try {
        let response = await this.$api.get("/suppliers/debits/", {
          params: {
            start_date: this.date,
            end_date: this.date2,
            breakdown: true,
            weekly: 2023,
          },
        });
        // console.log(response.data);

        let ledgeresp = await this.$api.get("/banking/ledger/charges/", {
          params: {
            start_date: this.date,
            end_date: this.date2,
          },
        });
        // console.log(response.data);


        this.ledger = ledgeresp.data;
        this.ledgerTotals = this.sumField(this.ledger, 'Value');
        
        this.debits = response.data.Debs;
        this.tabs = response.data.Tabs;
        this.breakdown = response.data.Breakdown;
        this.weekly = response.data.ByWeek;
        this.prepareLedgerPieChart();
        this.updateChart();
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
      
      
    },
    prepareLedgerPieChart() {
      // Aggregate by Action.Term
      const termMap = {};
      this.ledger.forEach(item => {
        const term = item.Action.Term;
        let include = true;

        // For -5 (taxes) and -6 (utilities), filter by first word of Remarks
        if (term === -5) {
          if (this.selectedTaxes && this.selectedTaxes.length > 0) {
            const firstWord = (item.Remarks || '').split(' ')[0];
            include = this.selectedTaxes.includes(firstWord);
          }
        }
        if (term === -6) {
          if (this.selectedUtilities && this.selectedUtilities.length > 0) {
            const firstWord = (item.Remarks || '').split(' ')[0];
            include = this.selectedUtilities.includes(firstWord);
          }
        }
        if (!include) return; // Skip this item


        if (!termMap[term]) {
          termMap[term] = {
            value: 0,
            desc: item.Action.Desc || `Term ${term}`,
          };
        }
        termMap[term].value += item.Value || 0;
      });

      // Prepare series and labels
      this.pieSeries = Object.values(termMap).map(e => e.value);
      this.ledgerPieLabels = Object.values(termMap).map(e => e.desc);

      // Update chart options
      this.pieOptions = {
        ...this.pieOptions,
        labels: this.ledgerPieLabels,
      };
    },
    functionEvents (date) {
      return this.debits.some(e => e.Date == date);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    updateChart () {
      let labels = [];
      let values =[{data: [], name: "Debit"}];
      for (let date in this.weekly ) {
        labels.push(date);
        values[0].data.push({
         x: date,
         y: this.weekly[date],
         });
      }
      this.series = values
      this.chartOptions = {xaxis: {type: "datetime", categories: labels, position: 'bottom'}}
    },

  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>ard
